
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BScChemistryCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Sc. Chemistry",
    shortName: "B.Sc. Chemistry",
    duration: "3 years",
    description: "Study of chemical substances, their properties, reactions, and applications",
    overview: "Bachelor of Science in Chemistry is a 3-year undergraduate program that provides comprehensive knowledge of chemical principles, laboratory techniques, and analytical methods. This course covers organic, inorganic, physical chemistry, and analytical chemistry, preparing students for careers in chemical industry, pharmaceuticals, research, quality control, and various analytical roles.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics/Biology",
      "Minimum 60% marks in science subjects",
      "Good laboratory skills and safety awareness",
      "Interest in chemical processes and analysis"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Inorganic Chemistry",
          "Organic Chemistry",
          "Physical Chemistry",
          "Mathematics",
          "Physics",
          "General English"
        ]
      },
      {
        year: 2,
        subjects: [
          "Analytical Chemistry",
          "Thermodynamics and Kinetics",
          "Coordination Chemistry",
          "Spectroscopy",
          "Environmental Chemistry",
          "Computer Applications"
        ]
      },
      {
        year: 3,
        subjects: [
          "Industrial Chemistry",
          "Biochemistry",
          "Polymer Chemistry",
          "Instrumental Methods",
          "Green Chemistry",
          "Research Project"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Analytical Chemist",
        "Quality Control Analyst",
        "Research Scientist",
        "Production Chemist",
        "Laboratory Technician",
        "Environmental Analyst",
        "Sales Representative",
        "Chemistry Teacher",
        "Forensic Analyst",
        "Food Technologist"
      ],
      industries: [
        "Pharmaceutical Industry",
        "Chemical Manufacturing",
        "Petrochemical Industry",
        "Food and Beverage",
        "Cosmetics Industry",
        "Environmental Monitoring",
        "Forensic Laboratories",
        "Educational Institutions",
        "Research Organizations",
        "Government Labs"
      ],
      averageSalary: "₹3-6 LPA (Fresher), ₹10-25 LPA (Experienced)",
      topRecruiters: [
        "DRDO, BARC, CSIR",
        "Reliance, ONGC, IOC",
        "Sun Pharma, Dr. Reddy's",
        "ITC, Hindustan Unilever",
        "Tata Chemicals, UPL",
        "Educational Institutions"
      ]
    },
    admissionProcess: [
      "Merit-based admission on 12th marks",
      "University entrance examinations",
      "Laboratory aptitude test",
      "Online application process",
      "Document verification and counseling"
    ],
    topColleges: [
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹25,000",
        ranking: "State University"
      },
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹65,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹20,000",
        ranking: "Government College"
      },
      {
        name: "PSG College of Arts and Science",
        location: "Coimbatore",
        fees: "₹55,000",
        ranking: "NAAC A+ Grade"
      }
    ],
    skills: [
      "Laboratory Techniques",
      "Analytical Methods",
      "Chemical Analysis",
      "Instrumentation",
      "Safety Protocols",
      "Data Interpretation",
      "Research Methodology",
      "Quality Control",
      "Problem Solving",
      "Technical Documentation"
    ],
    futureScope: "Growing opportunities in green chemistry, nanotechnology, pharmaceutical research, environmental analysis, and specialty chemicals with increasing focus on sustainable chemical processes.",
    faqs: [
      {
        question: "What are the main career paths for chemistry graduates?",
        answer: "Chemistry graduates can work in pharmaceuticals, chemical industry, quality control, research, environmental analysis, forensics, teaching, and sales/marketing of chemical products."
      },
      {
        question: "Is laboratory work mandatory in chemistry careers?",
        answer: "While many chemistry careers involve laboratory work, graduates can also pursue roles in sales, marketing, regulatory affairs, technical writing, and management that require chemistry knowledge but less lab work."
      },
      {
        question: "What higher education options are available?",
        answer: "Students can pursue M.Sc. Chemistry, specialized courses in analytical/organic chemistry, MBA, B.Ed., or professional courses in pharmaceutical sciences and environmental science."
      },
      {
        question: "Are there opportunities in emerging fields?",
        answer: "Yes, emerging opportunities exist in nanotechnology, green chemistry, pharmaceutical formulation, forensic science, and environmental monitoring with growing emphasis on innovation."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BScChemistryCoursePage;
